/**
 * Created by aahmed on 01/05/21.
 * AngularJS directive for Zoom Import
 */
angular.module('mediacloudApp')
    .directive('zoomImport', ['AssetService', 'BaseFileService', 'SchedulerService', 'atmosphereService', '$http', '$sce', '$state', function(AssetService, BaseFileService, SchedulerService, atmosphereService, $http, $sce, $state) {

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/collection/directives/zoom-import/zoom-import.html',
            scope: {
                openContent: '&',
                parent: '=',
                activeLink: '=',
                submissions: '=',
                collectionTree: '=',
                account: '='
            },

            link: function(scope, element, attrs) {
                scope.createdTable = false;
                scope.loading = true;
                scope.showZoomHeader = true;
                scope.showSearchInfo = false;
                scope.resultCount = 0;
                scope.searchValue = '';
                scope.disableBtn = true;
                scope.dataSrc = [];
                scope.dataDict = {};
                scope.searchQuery = '';
                scope.bottomSheetCount = 0;
                scope.totalBottomSheetCount = 0;
                scope.bottomSheetHtml = '';
                scope.batches = [];
                scope.batchCountText = '';
                scope.zoomItemSelectedForPublishing = {};
                scope.disableBatchDestination = false;
                scope.specialSort = false;
                scope.specialSortImported = false;
                scope.showProcessedAlert = false;
                scope.processedRecCount = 0;
                scope.processedAlertText = ' You have not selected a Destination Folder for processed recordings. Please click “Show Recordings” to highlight these recordings or cancel importing them.';
                scope.redirectToPlayback = false;
                var zoomStatuses = ['Not Imported', 'Processing', 'Importing', 'Published', 'Error'];
                var statusArr = ["Processing", "Uploading", "In Queue", "Processed", "Canceled"];

                var importAtmosphereSetup = function () {
                    if(!scope.account) {
                        return;
                    }
                    var request = {
                        url: scope.notificationUrl + 'zoom/import/' + scope.account.login,
                        contentType: 'application/json',
                        logLevel: 'debug',
                        transport: 'websocket',
                        fallbackTransport: 'streaming',
                        trackMessageLength: true,
                        reconnectInterval: 5000,
                        enableXDR: true,
                        timeout: 300000,
                        shared: true
                    };

                    request.onOpen = function(response) {
                        console.log('Atmosphere connected using ' + response.transport);
                    };

                    request.onMessage = function (response) {
                        try{
                            var message = JSON.parse(response.responseBody);
                            console.log('message atmosphere: ', message);
                            var batch;
                            if (message.messageType === 'transcode') {
                                processZoomBatchSummary(message.messageBody);
                            } else if (message.messageType === 'publish') {

                            }
                        }catch(err) {
                            console.log(err.message);
                        }
                    };

                    request.onClientTimeout = function (response) {
                        setTimeout(function () {
                            atmosphereService.subscribe(request);
                        }, request.reconnectInterval);
                    };
                    atmosphereService.subscribe(request);
                };

                var processZoomBatchSummary = function (batchSummary) {
//                    var batch = $filter('filter')(scope.batches, {batchId: batchSummary.id}, true)[0],
//                        transcodedCount = 0,
//                        totalProgress = 0;
                    if (batchSummary.meetingUuid != null) {
                        var rec = scope.parent.zoomRecordings.filter(function (el) {return el.uuid === batchSummary.meetingUuid})[0];
                        if (batchSummary.baseFile != null) {
                           rec.baseFileId = batchSummary.baseFile.id;
                           rec.fileId = batchSummary.baseFile.fileId;
                        }
                        // update recording in table
                        rec.progress = batchSummary.progress;
                        rec.displayInBottomSheet = batchSummary.displayInBottomSheet;
                        rec.destinationSet = batchSummary.destinationSet;
                        if (rec.displayInBottomSheet && statusArr.indexOf(rec.importedText) > -1) {
                            var bottomSheetRow = $('div[data-bottomsheetrowid="' + rec.id + '"');
                            if (bottomSheetRow.length) {
                                if (rec.progress) {
                                    var progress = Math.floor(rec.progress);
                                    $(bottomSheetRow).children('.percentage').html(progress + '%');
                                }
                            }
                        }
                        rec.importedText = capitalizeFirstLetter(batchSummary.importStatus.toLowerCase());
                        rec.progress = batchSummary.progress;
                        var recs = scope.parent.zoomRecordings.filter(function (el) {return el.importedText === 'Processed'});
                        if (recs.length === 0) {
                            scope.showProcessedAlert = false;
                        }
                        if (rec.importedText === 'Published') {
                            rec.collectionId = batchSummary.collectionId;
                            rec.showPublishHighlight = true;
                        }
                        scope.redrawTableWithOrder(scope.parent.zoomRecordings);
                    }
                };

                var capitalizeFirstLetter = function(str) {
                  return str.charAt(0).toUpperCase() + str.slice(1);
                }

                scope.redrawTable = function(data) {
                    var page = $('#zoomImport').DataTable().page();
                    $('#zoomImport').DataTable().clear().draw();
                    $('#zoomImport').DataTable().rows.add(JSON.parse(JSON.stringify(data))); // Add new data
                    $('#zoomImport').DataTable().columns.adjust().draw();
                    $('#zoomImport').dataTable().fnPageChange(page);
                    // renderBottomSheet(data);
                    $('[data-toggle="tooltip"]').tooltip();
                };

                scope.redrawTableWithOrder = function(data) {
                    $.each(data, function (k, v) {
                        v.order = getOrder(v.importedText);
                        v.orderImported = getOrderImported(v.importedText);
                    });
                    scope.specialSort = data.filter(function (el) { return el.importedText === 'Processing' || el.importedText === 'Uploading'}).length > 0;
                    scope.specialSortImported = data.filter(function (el) { return el.importedText === 'Processed' || el.importedText === 'Published'}).length > 0;
                    var order = [2, "desc"];
                    if (scope.specialSort) {
                        order = [7, "asc"];
                    }
                    else if (scope.specialSortImported) {
                        order = [8, "asc"];
                    }
                    else {
                        order = [2, "desc"];
                    }
                    var page = $('#zoomImport').DataTable().page();
                    $('#zoomImport').DataTable().clear().draw();
                    $('#zoomImport').DataTable().rows.add(JSON.parse(JSON.stringify(data))); // Add new data
                    $('#zoomImport').DataTable().columns.adjust().order(order).draw();
                    $('#zoomImport').dataTable().fnPageChange(page);
                    // renderBottomSheet(data);
                    $('[data-toggle="tooltip"]').tooltip();
                };

                scope.showAllProcessed = function(data) {
                    var recs = scope.parent.zoomRecordings.filter(function (el) {return el.importedText === 'Processed'});
                    $.each(recs, function (k, v) {
                        v.showProcessedHighlight = true;
                    });
                    scope.redrawTable(scope.parent.zoomRecordings);
                };

                scope.cancelAll = function(data) {
                    scope.cancelAllProcessed = new SchedulerService.CancelAll.get({}, function(response) {
                        scope.showProcessedAlert = false;
                    });
                };

                var getFinalIcon = function (row) {
                    if (row.importedText === 'Not Imported') {
                        return '<button data-id="' + row.id + '" class="zoom-navigable-btn zoom-import-r-btn" data-toggle="tooltip" data-placement="bottom" title="Import" style="background: none;outline: none;border: none;margin-right: 20px;top: 6px;position: relative;"><svg aria-label="Import Zoom Recording" class="zoom-import" data-id="' + row.id + '" xmlns="http://www.w3.org/2000/svg" width="22" height="22">    <path d="M.7 10.305c-.385 0-.7.336-.7.746v1.491c0 .41.315.746.7.746h4.893v-2.983H.7zm20.994-5.717L17.416.306A1.048 1.048 0 0 0 16.673 0h-.266v5.593H22v-.266c0-.276-.11-.542-.306-.739zm-6.53 1.256V0H6.619C6.05 0 5.593.46 5.593 1.031v9.344h5.47V7.573c0-.614.738-.92 1.17-.485l4.084 4.146a.734.734 0 0 1 0 1.032l-4.088 4.142a.685.685 0 0 1-1.171-.486v-2.797H5.593v7.844C5.593 21.54 6.05 22 6.62 22h14.356c.568 0 1.025-.46 1.025-1.031V6.875h-5.81a1.031 1.031 0 0 1-1.026-1.031z" fill="#098FD9" fill-rule="nonzero"/></svg></button>';
                    }
                    if (row.importedText === 'Canceled' || row.importedText === 'Error') {
                        return '<button data-id="' + row.id + '" class="zoom-navigable-btn zoom-import-r-btn" data-toggle="tooltip" data-placement="bottom" title="Retry" style="background: none;outline: none;border: none;margin-right: 20px;top: 6px;position: relative;"><svg xmlns="http://www.w3.org/2000/svg" width="23px" height="23px" viewBox="0 0 20 20">    <defs>        <filter id="a">            <feColorMatrix in="SourceGraphic" values="0 0 0 0 0.035294 0 0 0 0 0.560784 0 0 0 0 0.850980 0 0 0 1.000000 0"/>        </filter>    </defs>    <g transform="translate(-12 -130)" filter="#098fd9" fill="none" fill-rule="evenodd">        <path d="M28.393 140.163a.19.19 0 0 0-.194-.186l-1.712.035a.19.19 0 0 0-.187.194 4.403 4.403 0 0 1-2.2 3.888c-2.1 1.212-4.79.496-5.998-1.596-1.208-2.092-.483-4.78 1.616-5.992a4.427 4.427 0 0 1 2.612-.571l-.483 1.79a.19.19 0 0 0 .254.225l4.648-1.852a.19.19 0 0 0 .079-.294l-3.093-3.912a.19.19 0 0 0-.334.069l-.522 1.936a6.516 6.516 0 0 0-4.205.8c-3.099 1.79-4.17 5.759-2.386 8.848 1.784 3.089 5.756 4.146 8.855 2.357a6.499 6.499 0 0 0 3.25-5.739z" fill="#098fd9" fill-rule="nonzero"/>    </g></svg></button></td>';
                    }
                    if (row.importedText === 'Published') {
                        return '<button class="zoom-navigable-btn move-destination" data-id="' + row.id + '" data-toggle="tooltip" data-placement="bottom" title="Move Destination" style="background: none;outline: none;border: none;margin-right: 20px;top: 6px;position: relative;"><svg xmlns="http://www.w3.org/2000/svg" width="23" height="19">    <g fill="none" fill-rule="evenodd">        <path d="M22.515 5.547a2.222 2.222 0 0 0-2.219-2.218h-9.152L9.313.888A2.228 2.228 0 0 0 7.538 0H2.545A2.222 2.222 0 0 0 .326 2.218v4.387h22.189V5.547zM.326 8.209v8.143c0 .993.995 1.801 2.218 1.801h17.752c1.223 0 2.218-.808 2.218-1.8V8.208H.326z" fill="#098FD9"/>        <path d="M22.203 7.998v8.205c0 .378-.21.713-.529.959-.353.271-.841.435-1.378.435H2.544c-.536 0-1.025-.164-1.378-.435-.32-.246-.529-.581-.529-.959V7.998h21.566z" stroke="#098FD9" stroke-width=".623"/></g></svg></button>';
                    }
                    if (!row.destinationSet) {
                        // return '<button class="zoom-navigable-btn select-destination" data-id="' + row.id + '" data-toggle="tooltip" data-placement="bottom" title="Select Destination" style="background: none;outline: none;border: none;margin-right: 20px;top: 6px;position: relative;"><svg width="26" height="18" xmlns="http://www.w3.org/2000/svg">    <path d="m25.85 10.27-3.268 5.59a2.89 2.89 0 0 1-2.496 1.43H2.032a1.08 1.08 0 0 1-.935-1.625l3.269-5.59a2.89 2.89 0 0 1 2.495-1.43h18.054c.836 0 1.357.905.936 1.626zM6.862 7.205h14.806v-2.16c0-1.195-.97-2.162-2.167-2.162h-7.222L9.388 0H2.168A2.164 2.164 0 0 0 0 2.161v12.52L3.118 9.35a4.35 4.35 0 0 1 3.743-2.145z" fill="#098FD9" fill-rule="nonzero"/></svg></button>';
                        return '<button class="zoom-navigable-btn select-destination" data-id="' + row.id + '" style="background: none;outline: none;border: none;margin-right: 20px;top: 6px;position: relative;"><svg width="26" height="18" xmlns="http://www.w3.org/2000/svg">    <path d="m25.85 10.27-3.268 5.59a2.89 2.89 0 0 1-2.496 1.43H2.032a1.08 1.08 0 0 1-.935-1.625l3.269-5.59a2.89 2.89 0 0 1 2.495-1.43h18.054c.836 0 1.357.905.936 1.626zM6.862 7.205h14.806v-2.16c0-1.195-.97-2.162-2.167-2.162h-7.222L9.388 0H2.168A2.164 2.164 0 0 0 0 2.161v12.52L3.118 9.35a4.35 4.35 0 0 1 3.743-2.145z" fill="#098FD9" fill-rule="nonzero"/></svg></button>';
                    }
                    else {
                        return '<button disabled style="background: none;outline: none;border: none;margin-right: 20px;top: 6px;position: relative;"><svg xmlns="http://www.w3.org/2000/svg" width="23" height="19">    <g fill="none" fill-rule="evenodd" opacity=".5">        <path d="M22.515 5.547a2.222 2.222 0 0 0-2.219-2.218h-9.152L9.313.888A2.228 2.228 0 0 0 7.538 0H2.545A2.222 2.222 0 0 0 .326 2.218v4.387h22.189V5.547zM.326 8.209v8.143c0 .993.995 1.801 2.218 1.801h17.752c1.223 0 2.218-.808 2.218-1.8V8.208H.326z" fill="#098FD9"/>        <path d="M22.203 7.998v8.205c0 .378-.21.713-.529.959-.353.271-.841.435-1.378.435H2.544c-.536 0-1.025-.164-1.378-.435-.32-.246-.529-.581-.529-.959V7.998h21.566z" stroke="#098FD9" stroke-width=".623"/>    </g></svg></button>';
                    }
                };

                var getIcons = function (rec) {
                    var destinationIconStatus = ["Processing", "Uploading", "In Queue", "Processed"];
                    if (rec.importedText === 'Error') {
                        return '<button class="zoom-navigable-btn select-destination" data-id="' + rec.id + '"  data-toggle="tooltip" data-placement="bottom" title="Retry" style="float: right; background: none;outline: none;border: none;position: relative;"><svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 20 20">    <defs>        <filter id="a">            <feColorMatrix in="SourceGraphic" values="0 0 0 0 0.035294 0 0 0 0 0.560784 0 0 0 0 0.850980 0 0 0 1.000000 0"/>        </filter>    </defs>    <g transform="translate(-12 -130)" filter="#098fd9" fill="none" fill-rule="evenodd">        <path d="M28.393 140.163a.19.19 0 0 0-.194-.186l-1.712.035a.19.19 0 0 0-.187.194 4.403 4.403 0 0 1-2.2 3.888c-2.1 1.212-4.79.496-5.998-1.596-1.208-2.092-.483-4.78 1.616-5.992a4.427 4.427 0 0 1 2.612-.571l-.483 1.79a.19.19 0 0 0 .254.225l4.648-1.852a.19.19 0 0 0 .079-.294l-3.093-3.912a.19.19 0 0 0-.334.069l-.522 1.936a6.516 6.516 0 0 0-4.205.8c-3.099 1.79-4.17 5.759-2.386 8.848 1.784 3.089 5.756 4.146 8.855 2.357a6.499 6.499 0 0 0 3.25-5.739z" fill="#098fd9" fill-rule="nonzero"/>    </g></svg></button>';
                    }
                    if (destinationIconStatus.indexOf(rec.importedText) > -1 && !rec.destinationSet) {
                        // return '<button class="zoom-navigable-btn cancel-single" data-id="' + rec.id + '"  data-toggle="tooltip" data-placement="bottom" title="Cancel" style="float: right;background: none;outline: none; border: none;left: 5px;position: relative;bottom: 3px;"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"><path d="m4.849 4 2.564-2.564.528-.529a.2.2 0 0 0 0-.282L7.376.059a.2.2 0 0 0-.283 0L4 3.152.907.059a.2.2 0 0 0-.282 0L.059.624a.2.2 0 0 0 0 .283L3.152 4 .059 7.093a.2.2 0 0 0 0 .283l.565.565a.2.2 0 0 0 .283 0L4 4.85l2.564 2.564.529.528a.2.2 0 0 0 .283 0l.565-.565a.2.2 0 0 0 0-.283L4.85 4z" fill="#1A1A1A" fill-rule="nonzero"/></svg></button><button class="zoom-navigable-btn select-destination" data-id="' + rec.id + '"  data-toggle="tooltip" data-placement="bottom" title="Select Destination" style="float: right; background: none;outline: none;border: none;position: relative;"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="14"><path d="m19.885 7.9-2.515 4.3a2.223 2.223 0 0 1-1.919 1.1H1.563a.831.831 0 0 1-.72-1.25l2.515-4.3a2.223 2.223 0 0 1 1.92-1.1h13.887a.831.831 0 0 1 .72 1.25zM5.278 5.542h11.389V3.879c0-.918-.747-1.662-1.667-1.662H9.444L7.222 0H1.667C.747 0 0 .744 0 1.663v9.63l2.399-4.101a3.346 3.346 0 0 1 2.879-1.65z" fill="#098FD9" fill-rule="nonzero"/></svg></button>';
                        return '<button class="zoom-navigable-btn cancel-single" data-id="' + rec.id + '"  data-toggle="tooltip" data-placement="bottom" title="Cancel" style="float: right;background: none;outline: none; border: none;left: 5px;position: relative;bottom: 3px;"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"><path d="m4.849 4 2.564-2.564.528-.529a.2.2 0 0 0 0-.282L7.376.059a.2.2 0 0 0-.283 0L4 3.152.907.059a.2.2 0 0 0-.282 0L.059.624a.2.2 0 0 0 0 .283L3.152 4 .059 7.093a.2.2 0 0 0 0 .283l.565.565a.2.2 0 0 0 .283 0L4 4.85l2.564 2.564.529.528a.2.2 0 0 0 .283 0l.565-.565a.2.2 0 0 0 0-.283L4.85 4z" fill="#1A1A1A" fill-rule="nonzero"/></svg></button><button class="zoom-navigable-btn select-destination" data-id="' + rec.id + '"  uib-tooltip="Select Destination" tooltip-placement="bottom"  title="Select Destination" style="float: right; background: none;outline: none;border: none;position: relative;"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="14"><path d="m19.885 7.9-2.515 4.3a2.223 2.223 0 0 1-1.919 1.1H1.563a.831.831 0 0 1-.72-1.25l2.515-4.3a2.223 2.223 0 0 1 1.92-1.1h13.887a.831.831 0 0 1 .72 1.25zM5.278 5.542h11.389V3.879c0-.918-.747-1.662-1.667-1.662H9.444L7.222 0H1.667C.747 0 0 .744 0 1.663v9.63l2.399-4.101a3.346 3.346 0 0 1 2.879-1.65z" fill="#098FD9" fill-rule="nonzero"/></svg></button>';
                    }
                    else if (rec.importedText === 'Published') {
                        return '<button class="zoom-navigable-btn move-destination" data-id="' + rec.id + '" data-toggle="tooltip" data-placement="bottom" title="Move Asset" style="background: none;outline: none;border: none;    position: relative;float: right;right: 22px;"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="15">    <g fill="none" fill-rule="evenodd">        <path d="M17.62 4.341c0-.956-.779-1.736-1.736-1.736H8.721L7.288.695A1.744 1.744 0 0 0 5.9 0H1.991C1.034 0 .255.78.255 1.736V5.17H17.62v-.828zM.255 6.424v5.732c0 .7.779 1.268 1.736 1.268h13.893c.957 0 1.736-.568 1.736-1.268V6.424H.255z" fill="#098FD9"/>        <path d="M17.309 6.327v6.354c0 .275-.156.518-.388.696a1.709 1.709 0 0 1-1.037.327H1.99c-.404 0-.771-.122-1.037-.327-.232-.178-.388-.421-.388-.696V6.327H17.31z" stroke="#098FD9" stroke-width=".623"/>    </g></svg></button>';
                    }
                    else {
                        return '<button disabled style="float: right; background: none;outline: none;border: none;position: relative;"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="15">    <g fill="none" fill-rule="evenodd" opacity=".5">        <path d="M17.62 4.341c0-.956-.779-1.736-1.736-1.736H8.721L7.288.695A1.744 1.744 0 0 0 5.9 0H1.991C1.034 0 .255.78.255 1.736V5.17H17.62v-.828zM.255 6.424v5.732c0 .7.779 1.268 1.736 1.268h13.893c.957 0 1.736-.568 1.736-1.268V6.424H.255z" fill="#098FD9"/>        <path d="M17.309 6.327v6.354c0 .275-.156.518-.388.696a1.709 1.709 0 0 1-1.037.327H1.99c-.404 0-.771-.122-1.037-.327-.232-.178-.388-.421-.388-.696V6.327H17.31z" stroke="#098FD9" stroke-width=".623"/>    </g></svg></button>';
                    }
                };

                var getOrder = function (importedText) {
                    if (importedText == 'Error') {
                        return 1;
                    }
                    else if (importedText == 'Processed') {
                        return 2;
                    }
                    else if (importedText == 'Processing') {
                        return 3;
                    }
                    else if (importedText == 'Uploading') {
                        return 4;
                    }
                    else if (importedText == 'Not Imported') {
                        return 5;
                    }
                    else if (importedText == 'Canceled') {
                        return 6;
                    }
                    else if (importedText == 'Published') {
                        return 7;
                    }
                    else {
                        return 8;
                    }
                }

                var getOrderImported = function (importedText) {
                    if (importedText == 'Processed') {
                        return 1;
                    }
                    else if (importedText == 'Not Imported') {
                        return 2;
                    }
                    else if (importedText == 'Canceled') {
                        return 3;
                    }
                    else if (importedText == 'Published') {
                        return 4;
                    }
                    else {
                        return 5;
                    }
                }

                var renderBottomSheet = function (recordings) {
                    if (scope.specialSort) {
                        recordings.sort((a, b) => a.order - b.order);
                    }
                    scope.bottomSheetHtml = '';
                    scope.bottomSheetCount = 0;
                    scope.totalBottomSheetCount = 0;
                    $.each(recordings, function(k, v) {
                        if (v.displayInBottomSheet) {
                            if (statusArr[0] === v.importedText || statusArr[1] === v.importedText || v.importedText ===  "Published" || v.importedText === 'Processed') {
                                scope.bottomSheetCount++;
                            }
                            scope.totalBottomSheetCount++;
                            var paddingLeft = '12px';
                            if (v.importedText === 'Processing') {
                                paddingLeft = '14px';
                            }
                            if (v.importedText === 'Processed') {
                                paddingLeft = '16px';
                            }
                            if (v.importedText === 'Uploading') {
                                paddingLeft = '19px';
                            }

                            scope.bottomSheetHtml += '<div data-bottomsheetrowid="' + v.id + '" class="bottom-sheet-row row"><div class="col-md-5"><strong class="sheet-topic" data-toggle="tooltip" data-placement="bottom" title="' + v.topic + '" style="width: 24ch;text-align: left;text-decoration: none;text-overflow: ellipsis;white-space: nowrap;display: inline-block;overflow: hidden;position: relative;">' + v.topic + '</strong></div><div class="col-md-4">' + v.importedText + '<span style="padding-left: ' + paddingLeft + ';">' + ((v.progress && v.importedText != 'Published') ? Math.floor(v.progress) + '%' : '') + '</span></div><div class="col-md-3">' + getIcons(v) + '</div></div>'
                        }
                    });
                    scope.bottomSheetHtml = $sce.trustAsHtml(scope.bottomSheetHtml);
                    var allBottomSheetRecs = recordings.filter(function (el) {return el.displayInBottomSheet});
                    var importingCount = allBottomSheetRecs.filter(function (el) { return el.importedText === "Processing" || el.importedText === "Uploading" || el.importedText === "In Queue"}).length;
                    var importedCount = allBottomSheetRecs.filter(function (el) { return el.importedText === "Processed" || el.importedText === "Published" }).length;
                    var destinationSetCount = allBottomSheetRecs.filter(function (el) {return el.destinationSet});
                    scope.disableBatchDestination = destinationSetCount.length === allBottomSheetRecs.length;
                    if (importingCount > 0) {
                        scope.batchCountText = 'Importing ' + importingCount + ' of ' + allBottomSheetRecs.length + ' Recordings';
                    }
                    else if (importedCount === allBottomSheetRecs.length) {
                        scope.batchCountText = 'Imported ' + importedCount + ' of ' + allBottomSheetRecs.length + ' Recordings';
                    }
                    else {
                        scope.batchCountText = 'Importing... ';
                    }
                };

                scope.setBatchDestination = function () {
                   var allBottomSheetRecs = scope.parent.zoomRecordings.filter(function (el) {return el.displayInBottomSheet});
                   scope.selectZoomItemForPublishing({item: allBottomSheetRecs, isBatch: true, moveAsset: false });
                };

                var _rowStatus = '';

                scope.getZoomAssets = function() {
                    SchedulerService.GetZoomRecordings.get({
                        cid: scope.parent.cid,
                    }, function(result) {
                        scope.removeZoomImportDataTablesClass();
                        scope.parent.zoomRecordings = result.meetings;
                        scope.specialSort = scope.parent.zoomRecordings.filter(function (el) { return el.importedText === 'Processing' || el.importedText === 'Uploading'}).length > 0;
                        scope.specialSortImported = scope.parent.zoomRecordings.filter(function (el) { return el.importedText === 'Processed' || el.importedText === 'Published'}).length > 0;
                        // renderBottomSheet(result.meetings);
                       $.each(scope.parent.zoomRecordings, function(k, v) {
                            v.startTimeFormatted = moment(v.startTime).format("MMM. DD, YYYY");
                            v.idFormatted = v.id.replace(/\D+/g, '')
                                .replace(/(\d{3})(\d{4})(\d{4})/, '$1 $2 $3');
                        });
                        var processedRec = scope.parent.zoomRecordings.filter(function (el) { return el.showProcessedAlert });
                        scope.processedRecCount =  processedRec.length;
                        scope.showProcessedAlert =  scope.processedRecCount !== 0;
                        if (scope.showProcessedAlert && scope.processedRecCount === 1) {
                            var rec = processedRec[0];
                            var topicText = rec.topic;
                            if (topicText.length > 28) {
                                topicText = topicText.substring(0, 27).trim() + '...';
                            }
                            scope.processedAlertText = 'You have not selected a Destination Folder for "'+ topicText + '". Please select a destination for this recording or cancel importing it.'
                            $('#destinationProcessed').attr('data-id', rec.id);
                        }
                        if (!scope.createdTable && result.count > 0) {
                            scope.parent.noRecordings = false;
                            var order = [2, "desc"];
                            if (scope.specialSort) {
                                order = [7, "asc"];
                            }
                            else if (scope.specialSortImported) {
                                order = [8, "asc"];
                            }
                            else {
                                order = [2, "desc"];
                            }
                            var zoomImport = $('#zoomImport').DataTable({
                                "lengthChange": false,
                                "language": {
                                    search: '',
                                    searchPlaceholder: "Search for Zoom Recordings",
                                    info: "Displaying _START_-_END_ of _TOTAL_",
                                    paginate: {
                                        previous: '<span class="pagination-default"></span><span class="pagination-fa"><img src="/assets/images/left-paginate.png" width="5" height="8" style="margin-bottom: 5px;margin-right: 2px;"></span>',
                                        next: '<span class="pagination-default"></span><span class="pagination-fa"><img src="/assets/images/right-paginate.png" width="5" height="8" style="margin-bottom: 5px;margin-left: 2px;"></span>',
                                    }
                                },
                                "asStripeClasses": [],
                                "data": JSON.parse(JSON.stringify(scope.parent.zoomRecordings)),
                                "createdRow": function(row, data, dataIndex) {
                                    $(row).attr("id", "tblRow_" + data.imported);
                                    $(row).children().last().css('font-weight', 'bolder');
                                    $(row).children().last().css('opacity', '1');
                                    if (data.importedText.includes('Published') && !data.importedText.includes('Not')) {
                                        $(row).addClass('row-disabled');
                                        $(row).children().last().css('color', '#28a745');
                                        $(row).children().last().css('font-weight', 'bolder');
                                        if (data.showPublishHighlight) {
                                            $(row).addClass('row-publish-highlight');
                                        }
                                    } else if (((data.importedText.includes('Uploading') || data.importedText.includes('Processing') || data.importedText.includes('Processed') || data.importedText.includes('In Queue')) && data.destinationSet)) {
                                        $(row).addClass('row-disabled');
                                    }
                                    if (data.importedText.includes('Processed') && data.showProcessedHighlight) {
                                        $(row).addClass('row-processed-highlight');
                                    }
                                    if (data.importedText.includes('Processed')) {
                                        $(row).addClass('row-disabled');
                                    }
                                },
                                "columnDefs": [{
                                   "targets": 0,
                                     "className": 'select-checkbox',
                                      "searchable": false,
                                      "orderable": false,
                                      "data": "topic",
                                      'checkboxes': {
                                         'selectRow': true
                                      },
                                      'createdCell':  function (td, cellData, rowData, row, col) {
                                        setTimeout(() => {
                                             $(td).attr('tabindex', 0);

                                            if(!$(td).parent().hasClass('row-disabled')) {
                                                 $(td).click(function(){
                                                     if($(td).parent().hasClass('selected')) {
                                                         $(td).parent().removeClass('selected')
                                                     } else {
                                                        $(td).parent().addClass('selected')
                                                     }

                                                     scope.manageImportButton();
                                                 });
                                            }
                                        }, 1000);
                                      }
                                    },
                                    {
                                        "orderable": !scope.specialSort,
                                        "targets": [1, 2, 3, 4, 5]
                                    },
                                    {
                                      "orderable": false,
                                      "targets": [6]
                                    },
                                    {
                                        "orderData": [order[0]],
                                        "targets": [5]
                                    },
                                    {
                                        "visible": false,
                                        "targets": [7]
                                    },
                                    {
                                        "targets": [2],
                                        "type": 'datetime-moment'
                                    },
                                    {
                                        "targets": [2,3,4,5,6],
                                        "searchable": false
                                    },
                                    {
                                        "targets": [8],
                                        "visible": false,
                                        "searchable": false
                                    }
                                ],
                                "select": {
                                    style: 'multi',
                                    selector: 'td:first-child'
                                },
                                "columns": [{
                                        "data": "id",
                                        "render": function(data, type, row) {
                                            return '<td></td>'
                                        },
                                    },
                                    {
                                        "data": "topic",
                                        "orderable": !scope.specialSort,
                                        "render": function(data, type, row) {
                                            var tooltip = row.topic.length >= 45 ? 'data-toggle="tooltip" data-placement="bottom" title="' + row.topic + '"' : '';
                                            if (row.importedText === 'Not Imported' && !row.playFromZoomOpened) {
                                                return '<td><span ' + tooltip + ' style="color: #060606; margin-left: 6px;    display: block;    width: 33ch;    overflow: hidden;    white-space: nowrap;    text-overflow: ellipsis;"><svg style="margin-right: 6px; margin-bottom: 2px;" width="7" height="7" xmlns="http://www.w3.org/2000/svg"><circle cx="3.5" cy="3.5" r="3.5" fill="#FF8E00" fill-rule="evenodd"/></svg><span>' + data + '</span></span></td>';
                                            }
                                            else if (row.importedText === 'Published') {
                                                return '<td><a ' + tooltip + ' class="redirect-to-playback" data-id="' + row.id + '" style="cursor: pointer; color: #060606"><span style="margin-left: 6px;    display: block;    width: 33ch;    overflow: hidden;    white-space: nowrap;    text-overflow: ellipsis;"><svg style="margin-right: 4px;" xmlns="http://www.w3.org/2000/svg" width="10" height="10">    <g fill="#0091E6" fill-rule="evenodd">        <path d="m7.182 4.464-5.11-3.02c-.416-.246-1.052-.008-1.052.599v6.04c0 .545.59.873 1.051.6l5.11-3.02a.696.696 0 0 0 0-1.199z" fill-rule="nonzero" opacity=".848"/>        <path stroke="#0091E6" stroke-linejoin="round" d="m1.484 1.348 6.42 3.717-6.42 3.716z"/>    </g></svg><span style="color: initial;">' + data + '</span></span></a></td>';
                                            }
                                            else {
                                                return '<td><span ' + tooltip + ' style="color: #060606;     display: block;    width: 33ch;    overflow: hidden;    white-space: nowrap;    text-overflow: ellipsis;    padding-left: 19px;">' + data + '</span></td>';
                                            }
                                        },
                                    },
                                    {
                                        "orderable": !scope.specialSort,
                                        "data": "startTime",
                                        "render": function(data, type, row) {
                                            return '<td><span style="margin-left: 4px; font-weight: 300;">' + moment(data).format("MMM. DD, YYYY hh:mm a") + '</span></td>';
                                        },
                                    },
                                    {
                                        "orderable": !scope.specialSort,
                                        "data": "idFormatted",
                                        "render": function(data, type, row) {
                                            return '<td><span style="margin-left: 4px; font-weight: 300;">' + data + '</span></td>';
                                        },
                                    },
                                    {
                                        "data": "totalSizeFormatted",
                                        "orderable": !scope.specialSort,
                                        "render": function(data, type, row) {
                                            return '<td><span style="margin-left: 4px; font-weight: 300;">' + data + '</span></td>';
                                        },
                                    },
                                    {
                                        "data": "importedText",
                                        "orderable": !scope.specialSort,
                                        "render": function(data, type, row) {
                                            var className = 'badge zoom-badge ' + getClassName(data);
                                            _rowStatus = data;

                                            return '<td><span style="margin-left: 6px;" class="' + className + '">' + data + '</span></td>';
                                        },
                                    },
                                    {
                                        "data": "startTimeFormatted",
                                        "orderable": !scope.specialSort,
                                        "render": function (data, type, row) {
                                            var playUrl = row.recordingFiles[0].play_url;

                                            if (_rowStatus === 'Processing' || _rowStatus === 'Processed' || _rowStatus === 'Uploading' || _rowStatus === 'Canceled' || _rowStatus === 'Error') {
                                                return '<td>' +
                                                    '<a aria-label="Play from Zoom"  data-toggle="tooltip" data-placement="bottom" title="Play from Zoom" target="_blank" href="' + playUrl + '" style="margin-left: 25px; margin-right: 23px; position: relative; top: 2px;"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="14">    <path d="M12.89 6.5h-.468a.234.234 0 0 0-.235.234v5.86c0 .259-.21.469-.468.469H1.406a.469.469 0 0 1-.468-.47V2.282c0-.259.21-.469.468-.469h5.86c.13 0 .234-.104.234-.234V1.11a.234.234 0 0 0-.234-.234h-5.86C.63.875 0 1.505 0 2.281v10.313C0 13.37.63 14 1.406 14H11.72c.776 0 1.406-.63 1.406-1.406v-5.86a.234.234 0 0 0-.234-.234zM13.9 0 9.915.01a.352.352 0 0 0-.352.352v.292c0 .195.157.352.352.352l2.636-.01.02.02-7.975 7.78a.352.352 0 0 0 0 .499l.165.165a.352.352 0 0 0 .499 0l7.974-7.78.02.02-.01 2.637c0 .194.158.352.352.352h.293a.352.352 0 0 0 .352-.352l.01-3.985A.352.352 0 0 0 13.899 0z" fill="#1A1A1A" fill-rule="nonzero"/></svg></a>'  + getFinalIcon(row)
                                                + '</td>';
                                            }

                                            return '<td>' +
                                                '<a data-id="' + row.id + '" class="play-from-zoom" aria-label="Play Zoom Recording"  data-toggle="tooltip" data-placement="bottom" title="Play from Zoom" target="_blank" href="' + playUrl + '" style="margin-left: 25px; margin-right: 23px; position: relative; top: 2px;"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="14">    <path d="M12.89 6.5h-.468a.234.234 0 0 0-.235.234v5.86c0 .259-.21.469-.468.469H1.406a.469.469 0 0 1-.468-.47V2.282c0-.259.21-.469.468-.469h5.86c.13 0 .234-.104.234-.234V1.11a.234.234 0 0 0-.234-.234h-5.86C.63.875 0 1.505 0 2.281v10.313C0 13.37.63 14 1.406 14H11.72c.776 0 1.406-.63 1.406-1.406v-5.86a.234.234 0 0 0-.234-.234zM13.9 0 9.915.01a.352.352 0 0 0-.352.352v.292c0 .195.157.352.352.352l2.636-.01.02.02-7.975 7.78a.352.352 0 0 0 0 .499l.165.165a.352.352 0 0 0 .499 0l7.974-7.78.02.02-.01 2.637c0 .194.158.352.352.352h.293a.352.352 0 0 0 .352-.352l.01-3.985A.352.352 0 0 0 13.899 0z" fill="#1A1A1A" fill-rule="nonzero"/></svg></a>'  + getFinalIcon(row)
                                                + '</td>';
                                        }
                                    },
                                    {
                                        "data": "order"
                                    },
                                    {
                                        "data": "orderImported"
                                    },
                                ],
                                "order": [
                                    order
                                ],
                                "initComplete": function(){
                                     var api = this.api();
                                     api.columns.adjust().draw();
                                        $('.dataTables_filter input').unbind();
                                     // Populate a dataset for autocomplete functionality
                                     // using data from first, second and third columns
                                     api.cells('tr', [1, 6]).every(function(i, k){
                                        // Get cell data as plain text
                                        var data = $('<div>').html(this.data()).text();
                                        if (scope.dataDict[i] != undefined) {
                                            scope.dataDict[i] = scope.dataDict[i].concat(this.data());
                                        }
                                        else {
                                            scope.dataDict[i] = this.data() + '#%:';
                                        }
                                        console.log(i, k, data, scope.dataDict[i]);
                                        if(k === 6){
                                            scope.dataSrc.push(scope.dataDict[i]);
                                        }
                                     });

                                     // Sort dataset alphabetically
                                     scope.dataSrc.sort();

                                     var recordingBH = new Bloodhound({
                                       datumTokenizer: function (datum) {
                                               return Bloodhound.tokenizers.whitespace(datum.topic);
                                       },
                                       queryTokenizer: Bloodhound.tokenizers.whitespace,
                                       display: 'topic',
                                       local: scope.parent.zoomRecordings,
                                     });

                                     // Initialize Typeahead plug-in
                                     $('.dataTables_filter input[type="search"]')
                                        .typeahead({ minLength: 3, highlight: true, hint: false }, {
                                           source: recordingBH,
                                           displayKey: 'topic',
                                           templates: {
                                            suggestion: function (data) {
                                                var i = data.topic.toLowerCase().indexOf(data._query.toLowerCase());
                                                var len = data._query.length;
                                                var leftPart = data.topic.substr(0, i);
                                                var middlePart = data.topic.substr(i, len);
                                                var rightPart = data.topic.substr(i + len);
                                                var strong = $('<strong></strong>').text(middlePart);
                                                var html = '<div class="typeahead">';
                                                html += '<div class="pull-left margin-small">';
                                                html += '<div style="max-width: 220px;text-overflow: ellipsis;white-space: nowrap;overflow: hidden; color: #363636;" class="text-left">' + leftPart + '<strong>' + middlePart + '</strong>' + rightPart + '</div>';
                                                html += '<div class="text-left item-sub-text">' + data.startTimeFormatted + '</div>';
                                                html += '</div>';
                                                html += '<div class="clearfix"></div>';
                                                html += '</div>';
                                                return html;
                                            },
                                           empty: function(context){
                                            //  console.log(1) // put here your code when result not found
                                              $(".tt-dataset").html('<img src="/assets/images/telescope-duotone.png" style="width: 56px;    height: 49px;    justify-content: center;    display: flex;    margin: auto;    margin-top: 68px;    margin-bottom: 12px;"><div style="  width: 173px; margin: auto; margin-bottom: 5px; font-size: 14px;  font-weight: 500;  font-stretch: normal;  font-style: normal;  line-height: normal;  letter-spacing: normal;  text-align: center;  color: #000000;">There are no results for your search term.</div><p style="font-size: 10px;  font-weight: normal;  font-stretch: normal;  font-style: normal;  line-height: normal;  letter-spacing: normal;  text-align: center;  color: #4a4a4a;     width: 60%;margin: auto; margin-bottom: 76px;">Please try again with a different search term.</p>');
                                            }
                                           }
                                        }
                                     )
                                     .on('keyup', this, function (event) {
                                         if (event.keyCode == 13) {
                                             var searchTerm = $(this).val().toLowerCase().trim();
                                             if (!searchTerm) {
                                                 scope.performSearch = true;
                                                 api.search('');
                                                 api.draw();
                                                 $('.dataTables_filter input[type="search"]').typeahead('val', '');
                                                 return;
                                             }
                                             $.fn.dataTable.ext.search.push(function(settings, data, dataIndex) {
                                                for (var i=0;i<data.length;i++) {
                                                   if (data[i].trim().toLowerCase().includes(searchTerm)) return true
                                                }
                                                return false
                                             })
                                             api.draw();
                                             $.fn.dataTable.ext.search.pop();
                                            scope.performSearch = false;
                                            api.search(searchTerm, true, false, true );
                                            $('#import-btn span').hide();
                                            $('#zoomImport_info').hide();
                                         }
                                     })
                                     .on('typeahead:selected', function (e, suggestion, name) {
                                            var searchTerm = suggestion.topic.toLowerCase().trim();
                                            if (!searchTerm) {
                                                api.table.draw();
                                              return;
                                            }
                                            $.fn.dataTable.ext.search.push(function(settings, data, dataIndex) {
                                               for (var i=0;i<data.length;i++) {
                                                  if (data[i].trim().toLowerCase() == searchTerm) return true
                                               }
                                               return false
                                            })
                                            api.draw();
                                            $.fn.dataTable.ext.search.pop();
                                           scope.performSearch = false;
                                           api.search(suggestion.topic, true, false, true );
                                           $('#import-btn span').hide();
                                           $('#zoomImport_info').hide();
                                     });

                                     //if all rows are Published/Processed, disable check all
                                     var shouldDisableSelectAll = true;
                                     $('.contentTable .zoom-badge').each(function(k, v) {
                                         if($(v).text() !== 'Processed' &&  $(v).text() !== 'Published') {
                                             shouldDisableSelectAll = false;
                                         }
                                     });

                                    if(shouldDisableSelectAll) {
                                        $('.contentTable tr:first-child input[type="checkbox"]').attr('disabled', true);
                                        $('.contentTable tr:first-child').addClass('row-disabled');
                                        $('.contentTable tr:first-child #checkBoxLabel').hide();
                                    }
                                    scope.redrawTable(scope.parent.zoomRecordings);
                                }
                            });
                            zoomImport.on('draw.dt', function () {
                                console.log('page change')
                                $('.paginate_button').on('click', function() {
                                    $('.contentTable tr').removeClass('selected');
                                });

                                var indexes = zoomImport.rows( { page: 'current' }).eq( 0 ).filter( function (rowIdx) {
                                    return zoomImport.cell( rowIdx, 5 ).data() === 'Not Imported' ? true : false;
                                });
                                var count =  zoomImport.rows(indexes).count();
                                if (count === 0) {
                                    $('#checkBox').attr('disabled', 'true');
                                }
                                else {
                                    $('#checkBox').removeAttr('disabled');
                                }
                                $('#checkBox').prop('checked', false);
                                zoomImport.rows(indexes).deselect();
                                $('[data-toggle="tooltip"]').tooltip();
                            });
                            zoomImport.select.info(false);
                            $('#import-btn span').text($('#zoomImport_info').text());
                            $($("#import-btn").detach()).insertAfter("#zoomImport_filter");
                            $('<span id="searchBtn1" class="searchBtn search-icon"><svg width="14" height="14" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">    <defs>        <path id="a" d="M0 0h14v14H0z"/>    </defs>    <g fill="none" fill-rule="evenodd">        <mask id="b" fill="#fff">            <use xlink:href="#a"/>        </mask>        <path d="M10.062 5.687a4.374 4.374 0 1 0-8.75 0 4.374 4.374 0 1 0 8.75 0m3.84 7.598-.617.618a.325.325 0 0 1-.464 0l-3.32-3.32a.329.329 0 0 1-.095-.23V9.99a5.687 5.687 0 1 1 .584-.584h.362c.088 0 .168.033.231.096l3.32 3.32c.13.127.13.335 0 .463" fill="#3D3D3D" opacity=".75" mask="url(#b)"/>    </g></svg></span>').insertBefore($('.tt-input'));
                            $('<span id="clearBtn1" class="clearBtn"><i data-toggle="tooltip" data-placement="bottom" title="Clear Results" class="fa fa-times-thin fa-2x" aria-hidden="true"></i></span>').insertAfter($('.tt-input'));

                            $('[data-toggle="tooltip"]').tooltip();
                            $('#clearBtn1 i').click(function () {
                                scope.performSearch = true;
                                zoomImport.search('');
                                zoomImport.draw();
                                $('.dataTables_filter input[type="search"]').typeahead('val', '');
                            });

                            $('#searchBtn1').click(function () {
                                scope.performSearch = true;
                                zoomImport.search($('.tt-input').val());
                                zoomImport.draw();
                            });

                            $('.tt-dataset.tt-dataset-0').on('click', '.view-all', function () {
                                  scope.performSearch = true;
                                  zoomImport.search($('.tt-input').val());
                                  zoomImport.draw();
                             });

                            $('.tt-input').on('input', function () {
                                scope.performSearch = false;
                                zoomImport.search($(this).val(), true, false, true );
                                if ($(this).val().length > 0) {
                                    $('#clearBtn1 i').css('display', 'block');
                                }
                                else {
                                    $('#clearBtn1 i').css('display', 'none');
                                }
                            });

                            zoomImport.on('search.dt', function() {
                                var value = $('.tt-input').val();
                                scope.searchQuery = value;
                                if (value.length > 0) {
                                    $('#clearBtn1 i').css('display', 'block');
                                }
                                else {
                                    $('#clearBtn1 i').css('display', 'none');
                                }

                                var totalCount = zoomImport.rows({
                                    search: 'applied'
                                }).count();

                                scope.resultCount = totalCount;

                                if (value.length >=3 && totalCount === 0 && !scope.performSearch) {
                                    $('#viewAllDropdown').hide();
                                }
                                if (value.length >=3 && totalCount <= 1) {
                                    $('#viewAllDropdown').hide();
                                    $('.view-all').hide();
                                }

                                if (scope.performSearch && value != null && value != '') {
                                    scope.$evalAsync(function(){
                                        scope.showZoomHeader = false;
                                        scope.showSearchInfo = true;
                                    });

                                    scope.searchValue = '"' + value + '"';
                                    scope.resultCount = totalCount;
                                    $('#import-btn span').hide();
                                    $('#zoomImport_info').hide();
                                } else {
                                    scope.$evalAsync(function(){
                                        scope.showZoomHeader = true;
                                        scope.showSearchInfo = false;
                                    });
                                    $('#import-btn span').show();
                                    $('#zoomImport_info').show();
                                }
                            });

                            zoomImport.on('user-select', function ( e, dt, type, cell, originalEvent ) {
                                if (zoomImport.row(originalEvent.target._DT_CellIndex.row).data()["importedText"] !== 'Not Imported') {
                                    e.preventDefault();
                                }
                            });
                            $('#zoomImport').on('select.dt deselect.dt', function() {
                                var selectedLength = zoomImport.rows( { selected: true } ).indexes().length;
                                var disable = selectedLength === 0;
                                if (disable) {
                                    $('#import-btn button').attr('disabled', 'true');
                                }
                                else {
                                    $('#import-btn button').removeAttr('disabled');
                                }
                            });
                            $('#checkBox').click(function() {
                                var indexes = zoomImport.rows( { page: 'current' }).eq( 0 ).filter( function (rowIdx) {
                                    return zoomImport.cell( rowIdx, 5 ).data() === 'Not Imported' ? true : false;
                                });
                                if ($(this).prop('checked')) {
                                    zoomImport.rows(indexes).select();
                                    return;
                                }
                                else {
                                    zoomImport.rows(indexes).deselect();
                                }
                            });

                            $('#import-btn button').click(function () {
                                $('tr.selected').each(function(k, v){
                                    $(v).addClass('row-disabled');
                                });

                               var rows = zoomImport.rows( { selected: true } ).data();
                               console.log(rows.length)
                               if (rows.length === 1) {
                                   var meetingId = rows[0].id;
                                   var rec = scope.parent.zoomRecordings.filter(function (el) {return el.id === meetingId})[0];
                                   rec.formattedTopic = rec.topic.length > 28 ? rec.topic.slice(0,28) + '...' : rec.topic;
                                   scope.selectZoomItemForPublishing({item: rec, isBatch: false, moveAsset: false });
                               }
                               else {
                                  $.each(rows, function (k, v) {
                                       var meetingId = v.id;
                                       var rec = scope.parent.zoomRecordings.filter(function (el) {return el.id === meetingId})[0];
                                       rec.importedText = 'Uploading';
                                       rec.progress = 0;
                                       rec.displayInBottomSheet = true;
                                       scope.importZoomRecordingsRequest = new SchedulerService.ImportZoomRecordings.get({
                                           id: rec.importId,
                                           meetingId: meetingId,
                                           cid: scope.collectionTree.cid,
                                           displayInBottomSheet: true
                                       });
                                  });
                                scope.redrawTableWithOrder(scope.parent.zoomRecordings);
                               }
                              if ($('#checkBox').prop('checked') === true) {
                                  $('#checkBox').click();
                              }
                              $('#import-btn button').attr('disabled', 'true');
                            });

                            $(document).on("click",'.play-from-zoom',function(e){
                                 if ($(this).data('id') != null ) {
                                    var meetingId = $(this).data('id').toString();
                                    var rec = scope.parent.zoomRecordings.filter(function (el) {return el.id === meetingId})[0];
                                    scope.importZoomRecordingsRequest = new SchedulerService.SetPlayFromZoomOpened.get({
                                       meetingId: meetingId,
                                       meetingUuid: rec.uuid,
                                       cid: rec.baseFileId ? rec.collectionId : scope.collectionTree.cid,
                                   });
                                 }
                            });

                            // for individual zoom recordings
                            $(document).on("click",'.zoom-import-r-btn',function(e){
                                 if ($(this).data('id') != null ) {
                                    var meetingId = $(this).data('id').toString();
                                    var rec = scope.parent.zoomRecordings.filter(function (el) {return el.id === meetingId})[0];
                                    rec.formattedTopic = rec.topic.length > 28 ? rec.topic.slice(0,28) + '...' : rec.topic;
                                    scope.selectZoomItemForPublishing({item: rec, isBatch: false, moveAsset: false });
                                    if ($('#checkBox').prop('checked') === true) {
                                        $('#checkBox').click();
                                    }
//                                     var meetingId = $(this).data('id').toString();
//                                     var rec = scope.parent.zoomRecordings.filter(function (el) {return el.id === meetingId})[0];
//                                     rec.importedText = 'Uploading';
//                                     scope.redrawTable(scope.parent.zoomRecordings);
////                                     scope.importZoomRecordingsRequest = new SchedulerService.ImportZoomRecordings.get({
////                                       meetingId: meetingId.toString(),
////                                       cid: scope.collectionTree.cid,
////                                       displayInBottomSheet: false
////                                     });
//                                    if ($('#checkBox').prop('checked') === true) {
//                                         $('#checkBox').click();
//                                    }
                                 }
                            });


                            $(document).on("click",'#status-column',function(e){
                                scope.redrawTable(scope.parent.zoomRecordings);
                            });


                            // for individual zoom recordings
                            $(document).on("click",'.select-destination',function(e){
                                if ($(this).data('id') != null ) {
                                    var meetingId = $(this).data('id').toString();
                                    var rec = scope.parent.zoomRecordings.filter(function (el) {return el.id === meetingId})[0];
                                    rec.formattedTopic = rec.topic.length > 28 ? rec.topic.slice(0,28) + '...' : rec.topic;
                                    scope.selectZoomItemForPublishing({item: rec, isBatch: false, moveAsset: false });
                                    if ($('#checkBox').prop('checked') === true) {
                                        $('#checkBox').click();
                                    }
                                }
                            });

                            $(document).on("click", '.cancel-single', function (e) {
                                if ($(this).data('id') != null ) {
                                    var meetingId = $(this).data('id').toString();
                                    var rec = scope.parent.zoomRecordings.filter(function (el) {return el.id === meetingId})[0];

                                    scope.importZoomRecordingsRequest = new SchedulerService.CancelSingle.get({
                                        meetingUuid: rec.uuid,
                                        cid: rec.collectionId,
                                    }, function(response) {
                                        if(response.cancelled) {
                                            scope.getZoomAssets();
                                        }
                                    });
                                }
                            });

                            $(document).on("click",'.redirect-to-playback',function(e){
                                if ($(this).data('id') != null ) {
                                    var meetingId = $(this).data('id').toString();
                                    var rec = scope.parent.zoomRecordings.filter(function (el) {return el.id === meetingId})[0];

                                    if (!scope.redirectToPlayback) {
                                        BaseFileService.GetAssetId.get({id: rec.baseFileId}, function (response) {
                                            console.log('response: ', response);
                                            scope.redirectToPlayback = true;
                                            var collectionType = $state.current.name.toLowerCase();
                                            if ($state.current.name === 'lmsCourse') {
                                                $state.go('lmsPlayback', {
                                                    collectionType: 'course',
                                                    collectionId: rec.collectionId,
                                                    assetId: response.result
                                                });
                                            } else {
                                                $state.go('playback', {
                                                    collectionType: collectionType,
                                                    collectionId: rec.collectionId,
                                                    assetId: response.result
                                                });
                                            }
                                        }, function () {

                                        });
                                    }
                                }
                            });

                            $(document).on("click",'.move-destination',function(e){
                                if ($(this).data('id') != null ) {
                                    var meetingId = $(this).data('id').toString();
                                    var rec = scope.parent.zoomRecordings.filter(function (el) {return el.id === meetingId})[0];
                                    rec.formattedTopic = rec.topic.length > 28 ? rec.topic.slice(0,28) + '...' : rec.topic;
                                    scope.selectZoomItemForPublishing({item: rec, isBatch: false, moveAsset: true });
                                   if ($('#checkBox').prop('checked') === true) {
                                        $('#checkBox').click();
                                   }
                                }
                            });

                            zoomImport.on('select deselect', function(e, dt, type, indexes) {
                                var indexes = dt.rows().eq( 0 ).filter( function (rowIdx) {
                                    return dt.cell( rowIdx, 5 ).data() === 'Not Imported' ? true : false;
                                });

                                if (type === 'row') {
                                    // We may use dt instead of myTable to have the freshest data.
                                    if (dt.rows(indexes).count() === dt.rows(indexes, {
                                            selected: true
                                        }).count()) {
                                        // Deselect all items button.
                                        return;
                                    }

                                    if (dt.rows(indexes, {
                                            selected: true
                                        }).count() === 0) {
                                        // Select all items button.
                                        return;
                                    }
                                }
                            });
                            scope.createdTable = true;
                            scope.loading = false;
                        } else if (!result.count > 0) {
                            scope.parent.noRecordings = true;
                            scope.loading = false;
                        } else {
                            scope.parent.noRecordings = false;
                            scope.redrawTable(scope.parent.zoomRecordings);
                            scope.loading = false;
                        }
                        scope.parent.zoomUserId = result.userId;
                        scope.parent.zoomRecordingsCount = result.count;
                        setTimeout(function() {
                            $('[data-toggle="tooltip"]').tooltip();
                        }, 2500);
                    });
                };

                $(document).ready(function() {
                    $('[data-toggle="tooltip"]').tooltip();

                    $('body').on('DOMNodeInserted', 'a.paginate_button.current', function() {
                        $('.dataTables_wrapper .dataTables_paginate .paginate_button.current').attr('style', 'color: #FFF !important')
                    })

                    $('body').on('DOMNodeInserted', '.typeahead', function () {
                        if ($('#viewAllDropdown').text() == "") {
                            $('.tt-dataset').append('<div class="typeahead tt-suggestion tt-selectable view-all text-center"><a id="viewAllDropdown" class="dropdown-item">View All Results (' + scope.parent.zoomRecordings.filter(p => p.topic.toLowerCase().indexOf($('input.tt-input').val().toLowerCase()) > -1).length + ')</a></div>');
                        }
                    });

                    $(document.activeElement).keypress(function (e) {
                        if (e.which == 13 && $(e.target).hasClass('select-checkbox')) {
                            if ($(e.target).hasClass('sorting_disabled')) {
                                $(e.target).children().children().first().click();
                            }
                            else {
                                $(e.target).click();
                            }
                        }
                    });
                });


                var getClassName = function(text) {
                    if (text === 'Not Imported') {
                        return ' zoom-badge-ni';
                    }
                    if (text === 'Canceled') {
                        return ' zoom-badge-c';
                    }
                    if (text === 'Processing') {
                        return ' zoom-badge-p';
                    }
                    if (text === 'Processed') {
                        return ' zoom-badge-pd';
                    }
                    if (text === 'Uploading') {
                        return ' zoom-badge-u';
                    }
                    if (text === 'In Queue') {
                        return ' zoom-badge-q';
                    }
                    if (text === 'Published') {
                        return ' zoom-badge-pub';
                    }
                    if (text === 'Error') {
                        return ' zoom-badge-e';
                    }
                }

                // For accessible modals
                var modalFocus = function (first, last) {
                    var firstItem = $(first),
                        lastItem = $(last);

                    /*set focus on first item*/
                    firstItem.focus();

                    /*redirect last tab to first input*/
                    lastItem.on('keydown', function (e) {
                        if ((e.which === 9 && !e.shiftKey)) {
                            e.preventDefault();
                            firstItem.focus();
                        }
                    });

                    /*redirect first shift+tab to last input*/
                    firstItem.on('keydown', function (e) {
                        if ((e.which === 9 && e.shiftKey)) {
                            e.preventDefault();
                            lastItem.focus();
                        }
                    });
                };

                scope.selectZoomItemForPublishing = function (obj) {
                    scope.zoomfile = {
                        item: obj.isBatch ? obj.item : [obj.item],
                        isBatch: obj.isBatch,
                        moveAsset: obj.moveAsset,
                        publishTime: new Date().getUTCMilliseconds()
                    };
                    if (!obj.isBatch) {
                        scope.$apply();
                    }
                    else {
                        scope.zoomfile.formattedTopic = 'Batch with ' + obj.item.length + ' Zoom recordings ';
                        scope.zoomfile.topic = '';
                    }
                    $("#zoomPublishWindow").modal('show')
                    .on('shown.bs.modal', function () {
                        modalFocus('#publishHeading', '#returnTopublishHeading');
                        $('#returnTopublishHeading').on('focus', function () {
                            $('#publishHeading').focus()
                        });
                    });
                };

                scope.$watch('activeLink', function() {
                    if (scope.activeLink) {
                        if (scope.activeLink === 'zoomimport') {
                            scope.loading = true;
                            scope.getZoomAssets();
                            $http({
                                method: 'GET',
                                url: 'api/properties?name=NOTIFICATION_URL'
                            }).then(function successCallback(response) {
                                scope.notificationUrl = response.data.value;
                                console.log("notification URL: ", scope.notificationUrl);
                                importAtmosphereSetup();
                            });

                        }
                    }
                });

                scope.removeZoomImportDataTablesClass = function() {
                    setTimeout(() => {
                        $('table#zoomImport')[0].classList.remove('dataTable');
                    }, 0)
                }

                scope.selectAllCheckboxClick = function(e) {
                    if(e.target.checked) {
                        $('td.select-checkbox').each(function(k, v) {
                            if($(v).parent().find('.zoom-badge').text() !== 'Published' && $(v).parent().find('.zoom-badge').text() !== 'Processed') {
                                $(v).parent().addClass('selected');
                            }
                        })
                    } else {
                        $('td.select-checkbox').parent().removeClass('selected');
                    }

                    scope.manageImportButton();
                }

                scope.manageImportButton = function() {
                    var shouldEnable = false;
                    $('td.select-checkbox').each((index, item) => {
                        if($(item).parent().hasClass('selected')) {
                            shouldEnable = true;
                        }
                    })

                    if(shouldEnable) {
                        $('.btn.zoom-import').removeAttr('disabled');
                    } else {
                        $('.btn.zoom-import').attr('disabled', true);
                    }
                }
            }
        }
    }]);
